import React from 'react';

interface XwebaLogoProps {
  className?: string;
  size?: 'sm' | 'md' | 'lg' | 'xl';
  variant?: 'light' | 'dark'; // 'light' is for dark backgrounds (white 'xwe'), 'dark' is default (navy 'xwe')
  withTagline?: boolean; // kept for backwards compatibility
}

export const XwebaLogo: React.FC<XwebaLogoProps> = ({
  className = '',
  size = 'md',
  variant = 'dark',
}) => {
  const sizeClasses = {
    sm: 'text-xl tracking-tight',
    md: 'text-2xl sm:text-3xl tracking-tight',
    lg: 'text-3xl sm:text-4xl tracking-tight',
    xl: 'text-4xl sm:text-5xl tracking-tight',
  }[size];

  const isLight = variant === 'light';
  const xweColor = isLight ? 'text-white' : 'text-[#0B2D52]';
  const dotColor = isLight ? 'text-white' : 'text-[#0B2D52]';

  return (
    <div
      className={`inline-flex items-baseline font-black select-none font-sans leading-none ${sizeClasses} ${className}`}
      style={{ fontFamily: "'Plus Jakarta Sans', system-ui, sans-serif" }}
      aria-label="xweba."
    >
      <span className={`${xweColor} transition-colors`}>xwe</span>
      <span className="text-[#F26522]">ba</span>
      <span className={`${dotColor} transition-colors`}>.</span>
    </div>
  );
};
